import { CurrentAddressFormValues, PersonDataRequest } from '../../model';

export function formatCurrentAddress(
  values: CurrentAddressFormValues
): Pick<PersonDataRequest, 'currentAddress'> {
  return {
    currentAddress: {
      location: {
        country: values.country,
        region: values.region,
        province: values.province,
        cityOrMunicipality: values.cityOrMunicipality,
        barangay: values.barangay,
        postalCode: values.postalCode,
        streetAndHouse: values.streetAndHouse,
        unitAndFloor: values.unitAndFloor,
      },
    },
  };
}
